/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function() {
  if(window.location.hash.indexOf('#opencartdrawer') > -1) {
    document.getElementById('mini-cart').open = true;
    const url = window.location.href.replace("#opencartdrawer", "");
    history.replaceState(null, null, url);
  }
  new Swiper(".hero-slider_items-list", {
      navigation: {
          nextEl: ".hero-swiper-button-next",
          prevEl: ".hero-swiper-button-prev",
      },
      pagination: {
          el: ".hero-swiper-pagination",
          clickable: true
      },
  });

  new Swiper(".collection-image-slider_items-list", {
      navigation: {
          nextEl: ".collection-image-swiper-button-next",
          prevEl: ".collection-image-swiper-button-prev",
      },
      pagination: {
          el: ".collection-image-swiper-pagination",
          clickable: true
      },
  });
  // new Swiper(".customer-reviews_items-list", {
  //     slidesPerView: "auto",
  //     spaceBetween: 15,
  // });
  
  $('.gender-category_item-link').click(function(e){
      e.preventDefault();
      var tab_id = $(this).attr('target-id');
      console.log('tab_id',tab_id);
  
      $(this).closest('.gender-tabs_main').find('.gender-category_item-link').removeClass('is-active');
      $(this).closest('.gender-tabs_main').find('.gender-media_item').removeClass('is-active');
  
      $(`.gender-category_item-link[target-id="${tab_id}"]`).addClass('is-active');
      $("#"+tab_id).addClass('is-active');
  });
  
  $('.gender--tab_item-link').click(function(e){
      e.preventDefault();
      var tab_id = $(this).attr('target-id');
  
      $('.gender--tab_item-link').removeClass('is-active');
      $('.gender-tabs_main').removeClass('is-active');
  
      $(`.gender--tab_item-link[target-id="${tab_id}"]`).addClass('is-active');
      $("#"+tab_id).addClass('is-active');
  });

  if (window.innerWidth <= 749) {
    $('.footer__item-title').on('click', function () {
      $(this).toggleClass('is-active');
      $(this).next('.footer__item-content').stop(true, true).slideToggle();
    });
  }
  $('.pairs_well_with-title').click(function(e){
      $('.pairs_well_with').toggleClass('is-active');
      $('.pairs_well_with-product-list').slideToggle();
  });
  $('.product-meta_accordion-item_title').click(function() {
      $(this).toggleClass('active');
      $(this).next('.product-meta_accordion-item_content').slideToggle();
    
      // Toggle aria-expanded attribute
      var isExpanded = $(this).attr('aria-expanded') === 'true';
      $(this).attr('aria-expanded', !isExpanded);
  });
  // $("body").on("click", ".playSound", function(e) {
  //   e.preventDefault();
  //   $('audio').each(function(){
  //       this.pause(); // Stop playing
  //       this.currentTime = 0; // Reset time
  //   }); 
  
  //   $('.product-meta_audio-main').find('button').removeClass('stopSound is-selected').addClass('playSound')
  //   $(this).addClass('stopSound is-selected').removeClass('playSound')
  
  //     var id = $(this).attr('data-id')
  //     document.getElementById(id).play();
      
  // });

  // Pause when clicking the stop button — preserve position
  $("body").on("click", ".stopSound", function(e) {
    e.preventDefault();
    var audioEl = document.getElementById($(this).attr('data-id'));
    audioEl.pause();
    $(this).removeClass('stopSound is-selected').addClass('playSound');
  });

  // Play from preserved position
  $("body").on("click", ".playSound", function(e) {
    e.preventDefault();
    var audioEl = document.getElementById($(this).attr('data-id'));

    // Stop + reset every OTHER audio
    $('audio').not(audioEl).each(function() {
      this.pause();
      this.currentTime = 0;
    });
    $('.product-meta_audio-button').not(this).removeClass('stopSound is-selected').addClass('playSound');

    // Stop every video before the audio starts
    $('video').each(function() {
      this.pause();
      this.currentTime = 0;
    });

    audioEl.play();
    $(this).addClass('stopSound is-selected').removeClass('playSound');
  });

  // Global: call from any video's play event to stop all audio (position preserved)
  window.stopAudio = function() {
    $('.product-meta_audio-tag').each(function() { this.pause(); });
    $('.product-meta_audio-button')
      .removeClass('stopSound is-selected').addClass('playSound');
  };

  function formatTime(seconds) {
    if (isNaN(seconds)) return '0:00';
    var m = Math.floor(seconds / 60);
    var s = Math.floor(seconds % 60);
    return m + ':' + (s < 10 ? '0' + s : s);
  }

  // Paints the coloured fill behind the thumb via the --progress custom property
  // function setFill($progress, value, max) {
  //   var pct = max ? (value / max) * 100 : 0;
  //   $progress[0].style.setProperty('--progress', pct + '%');
  // }

  // Paints the fill — sets --progress on the wrapper so both the
  // scrubber gradient and the waveform overlay inherit it
  function setFill($el, value, max) {
    var pct = max ? (value / max) * 100 : 0;
    $el.closest('.product-meta_audio-wrapper')[0].style.setProperty('--progress', pct + '%');
  }

  $('.product-meta_audio-tag').each(function() {
  var audioEl   = this;
  var $wrap     = $(this).closest('.product-meta_audio-wrapper');
  var $track    = $wrap.find('.product-meta_audio-track');
  var $current  = $wrap.find('.product-meta_audio-current');
  var $duration = $wrap.find('.product-meta_audio-duration');
  var $progress = $wrap.find('.product-meta_audio-progress');
  var seeking   = false;

  // Build the waveform bars once — random base height + delay per bar
  // var barCount = 40;
  // var bars = '';
  // for (var i = 0; i < barCount; i++) {
  //   var h     = (0.25 + Math.random() * 0.75).toFixed(2); // silhouette 0.25–1.0
  //   var delay = (Math.random() * 0.6).toFixed(2);
  //   bars += '<span class="product-meta_audio-bar" style="--h:' + h + ';animation-delay:' + delay + 's;"></span>';
  // }
  // $track.html(bars);

  // Wave runs only while this audio is actually playing.
  // pause() from anywhere (button, stopAudio, video interrupt) fires 'pause',
  // so the wave stops automatically — no extra wiring needed.
  audioEl.addEventListener('play',  function() { $track.addClass('is-playing'); });
  audioEl.addEventListener('pause', function() { $track.removeClass('is-playing'); });

  function setDuration() {
    $duration.text(formatTime(audioEl.duration));
    $progress.attr('max', audioEl.duration || 100);
    setFill($progress, audioEl.currentTime, audioEl.duration);
  }

  if (audioEl.readyState >= 1) setDuration();
  audioEl.addEventListener('loadedmetadata', setDuration);

  audioEl.addEventListener('timeupdate', function() {
    $current.text(formatTime(audioEl.currentTime));
    if (!seeking) {
      $progress.val(audioEl.currentTime);
      setFill($progress, audioEl.currentTime, audioEl.duration);
    }
  });

  audioEl.addEventListener('ended', function() {
    $track.removeClass('is-playing'); // 'pause' doesn't fire on natural end
    $('.product-meta_audio-button[data-id="' + audioEl.id + '"]')
      .removeClass('stopSound is-selected').addClass('playSound');
  });

  $progress.on('input', function() {
    seeking = true;
    audioEl.currentTime = $(this).val();
    setFill($progress, $(this).val(), audioEl.duration);
  });
  $progress.on('change', function() { seeking = false; });
});

  // Pause (without reset) when block leaves viewport
  // document.querySelectorAll('.product-meta_audio').forEach(function(block) {
  //   var audio = block.querySelector('audio');
  //   var btn   = block.querySelector('.product-meta_audio-button');

  //   var observer = new IntersectionObserver(function(entries) {
  //     entries.forEach(function(entry) {
  //       if (!entry.isIntersecting && !audio.paused) {
  //         audio.pause();
  //         // NO currentTime reset here either
  //         $(btn).removeClass('stopSound is-selected').addClass('playSound');
  //       }
  //     });
  //   }, { threshold: 0 });

  //   observer.observe(block);
  // });

  // $("body").on("click", ".stopSound", function() {
  //   $(this).addClass('playSound').removeClass('stopSound')
  
  //   var id = $(this).attr('data-id')
  //   document.getElementById(id).pause()  
  //   document.getElementById(id).currentTime = 0;
    
  // });

  // $(document).on('click', '.product-meta-freecultr_in_action-button', function (e) {
  //   e.preventDefault();
  
  //   const $videoItem = $(this).closest('.product-meta-freecultr_in_action-video_item');
  //   const video = $videoItem.find('.product-meta-freecultr_in_action-video').get(0);
  
  //   // Stop all other videos
  //   $('.product-meta-freecultr_in_action-video_item').not($videoItem).each(function () {
  //     const otherVideo = $(this).find('video').get(0);
  //     otherVideo.pause();
  //     otherVideo.currentTime = 0;
  //     $(this).removeClass('play');
  //   });
  
  //   // Toggle current video
  //   if (video.paused) {
  //     video.play();
  //     $videoItem.addClass('play');
  //   } else {
  //     video.pause();
  //     $videoItem.removeClass('play');
  //   }
  // });

  (function ($) {
    const $popup = $('.fc-video-popup');
    const video = $popup.find('video')[0];
    const $mute = $popup.find('.fc-video-popup__mute');

    function syncMute() {
      $mute.toggleClass('is-muted', video.muted).toggleClass('is-unmuted', !video.muted);
    }

    function closePopup() {
      video.pause();
      video.currentTime = 0;
      video.innerHTML = '';
      video.removeAttribute('src');
      $popup.attr('hidden', true);
      $('html').removeClass('fc-video-popup-open');
    }

    $(document).on('click', '.product-meta-freecultr_in_action-button', function () {
      const sources = $(this)
        .closest('.product-meta-freecultr_in_action-media')
        .find('video')
        .html();

      video.innerHTML = sources;
      video.load();
      $popup.removeAttr('hidden');
      $('html').addClass('fc-video-popup-open');

      const p = video.play();
      if (p) p.catch(function () { video.muted = true; video.play(); });
      syncMute();
    });

    $(document).on('click', '.fc-video-popup__mute', function () {
      video.muted = !video.muted;
      syncMute();
    });

    $(document).on('click', '.fc-video-popup__close, .fc-video-popup__backdrop', closePopup);
    $(document).on('keydown', function (e) { if (e.key === 'Escape') closePopup(); });
  })(jQuery);

  (function () {
    if (typeof jQuery === 'undefined') return;
    jQuery(function ($) {
      var $slider = $('.product-reviews__slider');
      if (!$slider.length || typeof Swiper === 'undefined') return;

      // Destroy before re-init (guards against theme editor reloads)
      if ($slider[0].swiper) $slider[0].swiper.destroy(true, true);

      new Swiper('.product-reviews__slider', {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: $slider.find('.swiper-slide').length > 1,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        navigation: {
          prevEl: '.product-reviews__nav--prev',
          nextEl: '.product-reviews__nav--next'
        }
      });

      var $modal = $('#ProductReviewsModal');

      // Open — show the popup item matching the clicked card's index
      $(document).off('click.reviews keydown.reviews').on('click.reviews', '.product-reviews__card', function () {
          var index = $(this).attr('data-review-index');
          $modal.find('.product-reviews__popup-item').removeClass('is-active');
          $modal.find('.product-reviews__popup-item[data-review-index="' + index + '"]').addClass('is-active');
          $modal.addClass('is-open').attr('aria-hidden', 'false');
        })

      // Close
      $modal.off('click.reviews').on('click.reviews', '[data-review-close]', function () {
        $modal.removeClass('is-open').attr('aria-hidden', 'true');
      });
    });
  })();
  
  $('body').on('click', '.pairs_well_with-product-item-button.add', function (e) {
    e.preventDefault();
    var _this = this;
    this.setAttribute('disabled', 'disabled');
    this.setAttribute('aria-busy', 'true');
  
    var variant_id = parseInt($(this).attr('variant_id'));
    console.log('variant_id',variant_id);
    var line_item_data = JSON.stringify({ quantity: 1, id: variant_id })
  
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      // async: false,
      data: line_item_data,
      contentType: 'application/json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      },
      success: function() {
          $.getJSON("/cart.js", function (cart) {
              document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                  bubbles: true,
                  detail: { cart }
              })); 
          });
          document.getElementById('mini-cart').open = true;
          $(_this).removeAttr('disabled');
          $(_this).removeAttr('aria-busy');
          console.log('success');
      }
    });
  });
  
  $('body').on('click', '.payment-summary_total', function (e) {
     $(this).parents('.payment-summary').toggleClass('show');
     $(this).parents('.payment-summary').find('.payment-summary_body').slideToggle();
  });

  var pInfScrLoading = false;
  var pInfScrDelay = 100;
  
  function pInfScrExecute(_this) {
    var loadingImage;
    pInfScrNode = $(_this).closest('.collection-view-more-button_wrapper').last();	
    pInfScrURL = $(_this).last().attr("next_url");
    if(!pInfScrLoading && pInfScrNode.length > 0) {
      console.log(pInfScrURL)
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          pInfScrLoading = true;
        },
        success: function(data) {        
            var filteredData = $(data).find(".product-list__inner");
            $(_this).closest('.product-facet__main').find('.product-list__inner').append(filteredData.html());
            $(_this).closest('.featured-collections').find('.product-list__inner').append(filteredData.html());
            $(_this).closest('.collection-view-more-button_wrapper').html($(data).find('.collection-view-more-button_wrapper').html());
            $(this).attr("aria-busy","false");
            pInfScrLoading = false;
        },
        dataType: "html"
      });
    }
  }
  // $('body').on('click', '.collection-view-more-button', function(e) {
  //   e.preventDefault();
  //   $(this).attr("aria-busy","true");
  //   pInfScrExecute(this);
  // });
  $(document).ready(function () {
    var scrollTimer;
    $(window).scroll(function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var btn = $('.collection-view-more-button').last();
        // fire when the button is within 400px of the viewport bottom
        if (btn.length && btn.offset().top - 400 < $(window).scrollTop() + $(window).height()) {
          pInfScrExecute(btn[0]);
        }
      }, pInfScrDelay);
    });
  });

  $('.sticky-form_select-size-button').on('click', function (e) {
    e.preventDefault();
  
    const $target = $('.product-form__option-selector.size');
  
    if ($target.length) {
      // Scroll smoothly to the section
      $('html, body').stop().animate({
        scrollTop: $target.offset().top - 200 // adjust offset as needed
      }, 600);
  
      // Add shaking class
      $target.addClass('shaking');
  
      // Remove shaking after 2 seconds
      setTimeout(() => {
        $target.removeClass('shaking');
      }, 1200);
    }
  });
  $('.product-form_select-size-button').on('click', function (e) {
    e.preventDefault();
    const $target = $('.product-form__option-selector.size');
    if ($target.length) {
      // Add shaking class
      $target.addClass('shaking');
  
      // Remove shaking after 2 seconds
      setTimeout(() => {
        $target.removeClass('shaking');
      }, 1200);
    }
  });
  
  $('.mega-menu__title').on('mouseenter', function () {
    var activeTab = $(this).attr('title');
  
    $(this).closest('.mega-menu__inner').find('.mega-menu__title').removeClass('is-active');
    $(this).closest('.mega-menu__inner').find('.mega-menu__image-push').removeClass('is-active');
  
    $(this).addClass('is-active');
    $(this).closest('.mega-menu__inner').find(`.mega-menu__image-push[submenu="${activeTab}"]`).addClass('is-active');
  });
  
  $('.mobile-menu-item-link').on('click', function () {
    var activeTab = $(this).attr('title');
  
    $('.mobile-menu-item-link').removeClass('is-active');
    $('.mobile-submenu-list_main').removeClass('is-active');
  
    $(this).addClass('is-active');
    $(`.mobile-submenu-list_main[main-menu="${activeTab}"]`).addClass('is-active');
  });
  
  $('.mobile-submenu-item-link').on('click', function () {
    var activeTab = $(this).attr('title');
  
    $(this).closest('.mobile-submenu-list_main').find('.mobile-submenu-item-link').removeClass('is-active');
    $(this).closest('.mobile-submenu-list_main').find('.mobile-menu__image-push').removeClass('is-active');
  
    $(this).addClass('is-active');
    $(`.mobile-menu__image-push[submenu="${activeTab}"]`).addClass('is-active');
  });
  $('.mobile-menu-item-link[title="shop-men"]').trigger('click');
  // var input_value = $('.line-item-property-input').find('input').val();

  $('body').on('keyup','.pincode-checker #pincode-input', function(i,e){
    $(this).closest('.pincode-checker').find('.pincode-checker__submit').removeAttr('disabled');
  });

  // Update the count down every 1 second
  if(document.getElementById('announcement-timer_main')){
    var x = setInterval(function () {
      // Set the date we're counting down to
      var countDownDate = new Date(document.getElementById('announcement-timer_main').getAttribute('data-time')).getTime();
  
      // Get today's date and time
      var now = new Date().getTime();
  
      console.log('countDownDate',document.getElementById('announcement-timer_main').getAttribute('data-time'),countDownDate,now);
      // Find the distance between now and the count down date
      var distance = countDownDate - now;
  
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
      var days_content = '',
        hours_content = '',
        minutes_content = '',
        seconds_content = '';
      if (days > 0) {
        days_content = `<div class="announcement-timer_item"><span class="announcement-timer_item-val"><span class="numval">${String(days).padStart(2,'0')}</span>days</span></div>`;
      }
      if (hours > 0) {
        hours_content = `<div class="announcement-timer_item"><span class="announcement-timer_item-val"><span class="numval">${String(hours).padStart(2,'0')}</span>hrs</span></div>`;
      }
      minutes_content = `<div class="announcement-timer_item"><span class="announcement-timer_item-val"><span class="numval">${String(minutes).padStart(2,'0')}</span>mins</span></div>`;
      seconds_content = `<div class="announcement-timer_item"><span class="announcement-timer_item-val"><span class="numval">${String(seconds).padStart(2,'0')}</span>secs</span></div>`;
      // Display the result in the element with id="demo"
      $('.announcement-timer_main').each(function (index) {
        $(this).html(`
            ${days_content}
            ${hours_content}
            ${minutes_content}
            ${seconds_content}
          `);
      });
  
      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        console.log('innn')
        $('.announcement-timer_main-wrapper').hide();
        $('body').addClass('hide_timer');
      }
    }, 1000);
  }
  
  const COLOR_ONLY = true;

  document.addEventListener("change", (event) => {
    const target = event.target;
    if (!target.matches?.("input[data-option-position], select[data-option-position]")) return;
    if (target.closest("quick-add-modal, dialog, .quick-add, [id*='quick']")) return;

    // log so you can confirm what's changing
    console.log("changed:", target.getAttribute("name"), "position:", target.getAttribute("data-option-position"));

    if (COLOR_ONLY && target.getAttribute("data-option-position") !== "1") return;

    if (window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  });


  // $('.product__media-tab_button').click(function(){
  //   $('.product__media-tab_button').removeClass('is-active');
  //   $(this).addClass('is-active');
  //   $('.product__media').hide();
    
  //   var activeTab = $(this).attr('data-href');
  //   $(`[data-id="${activeTab}"]`).show();
  //   return false;
  // });
  $('.product__media-tab_button').click(function(){
    $('.product__media-tab_button').removeClass('is-active');
    $(this).addClass('is-active');
    $('.product__media').hide();

    var activeTab = $(this).attr('data-href');
    var $activePanel = $(`[data-id="${activeTab}"]`);
    $activePanel.show();

    // stop all videos
    $('.product__media video').each(function(){
      this.pause();
      this.currentTime = 0;
    });

    // play only the active panel's video (Gallery has none, so nothing plays)
    var video = $activePanel.find('video')[0];
    if (video) {
      if (window.stopAudio) stopAudio();
      video.play();
    }

    return false;
  });

  document.addEventListener('play', function(e) {
    if (e.target.tagName === 'VIDEO' && window.stopAudio) stopAudio();
  }, true);

    $("body").on("click",".product-meta-money-back-text", function() {
      $(this).toggleClass("active");
    })
});

// $(document).ready(function() {
//   $('body').on('click', '.product-item__cta_freemini', function(e) {
//     e.preventDefault();
//     $('.product-item__cta_freemini').attr('disabled','disabled');
//     var variant_id = $(this).attr('data-vid');
    
//     $(this).attr("aria-busy",true);
//     var items = [];
//     items.push({
//       quantity: 1,
//       id: variant_id,
//       properties:{ 
//         "_freemini": true,
//         "_mini_type": $(this).attr('data-type')
//       } 
//     });   
    
//     var data = {items};
//     console.log('data',data)
    
//     fetch('/cart/add.js', {
//       method: 'POST',
//       body: JSON.stringify(data),
//       credentials: 'same-origin',
//       headers: {
//         'Content-Type': 'application/json; charset=UTF-8',
//         'X-Requested-With': 'XMLHttpRequest'
//       }
//     })
//     .then(response => response.json())
//     .then(function(data) {     
//       $.getJSON('/cart.js', function(cart){
//         document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
//           bubbles: true,
//           detail: {
//             cart: cart
//           }
//         }));
//       });
//       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//         bubbles: true
//       }));
//       // document.getElementById('mini-cart').open = true;
//       $(this).removeAttr("aria-busy");
//     }.bind(this));  
  
//   });
// });
$(document).ready(function() {

  function addFreeMini($btn, variant_id, mini_type) {
    var $all = $('.product-item__cta_freemini, .product-item__cta_freemini-variant, .product-item__cta_freemini-modal, .js-claim-option');
    $all.attr('disabled', 'disabled');
    $btn.addClass('is-selected').attr('aria-busy', true);

    var data = {
      items: [{
        quantity: 1,
        id: variant_id,
        properties: {
          "_freemini": true,
          "_mini_type": mini_type
        }
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(function(response) {
      if (!response.ok) throw response;
      return response.json();
    })
    .then(function() {
      $.getJSON('/cart.js', function(cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cart }
        }));
      });
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    })
    .catch(function() {
      $all.not('.is-soldout').removeAttr('disabled');
      $all.removeAttr('aria-busy');
      $btn.removeClass('is-selected');
    });
  }

  // loader-button wraps its content, so update the inner text when it exists
  function setButtonText($btn, text) {
    var $text = $btn.find('.loader-button__text');
    ($text.length ? $text : $btn).text(text);
  }

  function setActive($option, active) {
    $option.toggleClass('is-active', active);
  }

  function setSoldout($option, soldout) {
    $option.toggleClass('is-soldout', soldout).prop('disabled', soldout);
  }

  // Refresh sold-out options and the claim button from the current selection
  function updateModal($modal) {
    var variants = JSON.parse($modal.find('.mini-cart__claim-modal-json').text());
    var $rows = $modal.find('.js-claim-row');
    var $claim = $modal.find('.product-item__cta_freemini-modal');

    var selected = [];
    $rows.each(function() {
      var $active = $(this).find('.js-claim-option.is-active');
      selected.push($active.length ? $active.attr('data-value') : null);
    });

    // Disable values that have no available variant with the other selected values
    $rows.each(function(index) {
      $(this).find('.js-claim-option').each(function() {
        var $option = $(this);
        var value = $option.attr('data-value');
        var available = variants.some(function(v) {
          if (!v.available || v.options[index] !== value) return false;
          return selected.every(function(sel, i) {
            return i === index || sel === null || v.options[i] === sel;
          });
        });

        setSoldout($option, !available);

        if (!available && $option.hasClass('is-active')) {
          setActive($option, false);
          selected[index] = null;
        }
      });
    });

    // Hidden rows (e.g. Gender) are never picked by the customer, so keep them on the first available value
    $rows.filter('[hidden]').each(function() {
      var index = $rows.index(this);
      if (selected[index] !== null) return;

      var $first = $(this).find('.js-claim-option').not('.is-soldout').first();
      if ($first.length) {
        setActive($first, true);
        selected[index] = $first.attr('data-value');
      }
    });

    // Show the selected value next to each option name
    $rows.each(function(index) {
      $(this).find('.js-claim-value').text(selected[index] || '');
    });

    $claim.removeAttr('data-vid');

    var missing = selected.indexOf(null);
    if (missing > -1) {
      setButtonText($claim, 'SELECT ' + $rows.eq(missing).attr('data-name').toUpperCase());
      return;
    }

    var variant = variants.find(function(v) {
      return v.available && selected.every(function(sel, i) {
        return v.options[i] === sel;
      });
    });

    if (variant) {
      $claim.attr('data-vid', variant.id);
      setButtonText($claim, 'CLAIM');
    } else {
      setButtonText($claim, 'SOLD OUT');
    }
  }

  // Single variant product: add directly
  $('body').on('click', '.product-item__cta_freemini', function(e) {
    e.preventDefault();
    addFreeMini($(this), $(this).attr('data-vid'), $(this).attr('data-type'));
  });

  // Multi variant product: open variant modal
  $('body').on('click', '.product-item__cta_freemini-variant', function(e) {
    e.preventDefault();
    var $item = $(this).closest('.product-item');
    updateModal($item.find('.mini-cart__claim-modal'));
    $item.addClass('is-claim-open');
  });

  // Close modal
  $('body').on('click', '.mini-cart__claim-modal-close, .mini-cart__claim-modal-overlay', function(e) {
    e.preventDefault();
    $(this).closest('.product-item').removeClass('is-claim-open');
  });

  // Option value (text or swatch): select it in its row and refresh the modal
  $('body').on('click', '.js-claim-option', function(e) {
    e.preventDefault();
    if ($(this).is(':disabled') || $(this).hasClass('is-soldout')) return;

    setActive($(this).closest('.js-claim-row').find('.js-claim-option'), false);
    setActive($(this), true);
    updateModal($(this).closest('.mini-cart__claim-modal'));
  });

  // Modal claim button: add matched variant, or shake the rows still unselected
  $('body').on('click', '.product-item__cta_freemini-modal', function(e) {
    e.preventDefault();
    var variant_id = $(this).attr('data-vid');

    if (!variant_id) {
      var $rows = $(this).closest('.mini-cart__claim-modal').find('.js-claim-row').not('[hidden]').filter(function() {
        return !$(this).find('.js-claim-option.is-active').length;
      });
      if (!$rows.length) return;

      $rows.removeClass('is-shaking');
      $rows[0].offsetWidth; // restart animation on repeat clicks
      $rows.addClass('is-shaking');
      setTimeout(function() { $rows.removeClass('is-shaking'); }, 500);
      return;
    }

    addFreeMini($(this), variant_id, $(this).attr('data-type'));
  });

});

$('.free_gift-modal-close').click(function(e){
    e.preventDefault();
    $('#free_gift-modal_main').fadeOut();
    $('#free_gift-modal_main').removeClass('active');
  });

/* ---------------------------------------------------------------------------
   Free-gift reconciliation gate
   ---------------------------------------------------------------------------
   Shopify recalculates the automatic gift discount the instant the cart
   changes, so the cart that /cart/change.js or /cart/add.js hands back is an
   INTERMEDIATE state: the quantity is already updated and the discount is
   already gone, but the gift line is still sitting in the cart. Painting that
   state is what makes the drawer total read 500 -> 600 -> 400 instead of
   500 -> 400.

   The `cart:updated` handler below decides synchronously whether it has to add
   or remove a gift. When it does, it flips this gate on before firing its ajax,
   and every dispatcher of the intermediate `cart:refresh` skips its render and
   hands its detail over here instead. settle() then fires the single
   authoritative refresh once the cart has stopped moving.
--------------------------------------------------------------------------- */
window.FreeGiftGate = {
  // True while a gift add/remove is in flight. Read by cart:refresh dispatchers.
  busy: false,

  // Detail of the render(s) we swallowed; non-null means a render is owed.
  suppressedDetail: null,

  begin: function () {
    this.busy = true;
  },

  // Called by a dispatcher that skipped its own cart:refresh. Whatever that
  // render was going to do (open the drawer, etc.) is carried to settle().
  suppress: function (detail) {
    this.suppressedDetail = Object.assign({}, this.suppressedDetail, detail || {});
  },

  // Ends the reconciliation and paints once. `cart` may be null, in which case
  // the drawer re-fetches the section itself.
  settle: function (cart) {
    var owedRender = this.suppressedDetail !== null;
    var detail = this.suppressedDetail || {};

    this.busy = false;
    this.suppressedDetail = null;

    if (cart) detail.cart = cart;

    if (owedRender || cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: detail
      }));
    }
  }
};


document.addEventListener('cart:updated', function (event) {
  var cart = event.detail.cart;

  function refreshCart() {
    $.getJSON('/cart.js', function (cart) {
      window.FreeGiftGate.settle(cart);
    });
  }

  var settings = window.themeVariables.settings;

  var free_product = settings.free_product;
  var freeProductThresholdSetting = settings.free_product_threshold;

  var second_free_product = settings.second_free_product;
  var secondFreeProductThresholdSetting = settings.second_free_product_threshold;

  var freeProductAdded = false;
  var secondFreeProductAdded = false;

  // Normalize excluded product IDs.
  var rawExcept = settings.no_free_gift_products;
  var exceptIds = [];

  if (typeof rawExcept === 'string') {
    exceptIds = rawExcept.split(',').filter(Boolean).map(Number);
  } else if (Array.isArray(rawExcept)) {
    exceptIds = rawExcept.map(function (p) {
      return Number(p && p.id != null ? p.id : p);
    });
  }

  var carttotal = 0;

  cart.items.forEach(function (item) {
    var productId = Number(item.product_id);

    if (productId === Number(free_product?.id)) {
      freeProductAdded = true;
    }

    if (productId === Number(second_free_product?.id)) {
      secondFreeProductAdded = true;
    }

    var isFreeMini = item.properties && item.properties['_freemini'];
    var isExcepted = exceptIds.indexOf(productId) > -1;

    if (
      !isFreeMini &&
      !isExcepted &&
      productId !== Number(free_product?.id) &&
      productId !== Number(second_free_product?.id)
    ) {
      carttotal += item.final_line_price;
    }
  });

  var hasNoFreeGiftProduct = cart.items.some(function (item) {
    return exceptIds.indexOf(Number(item.product_id)) > -1;
  });

  var total = (carttotal / 100).toFixed(2);

  var freeProductThreshold = parseInt(freeProductThresholdSetting);
  var secondFreeProductThreshold = parseInt(secondFreeProductThresholdSetting);

  $('#mini-cart [name="checkout"]')
    .addClass('gokwik-marge')
    .attr('disabled', 'disabled');

  const showModal = (duration = 3000) => {
    const modal = $('#free_gift-modal_main');

    modal.fadeIn().addClass('active');

    setTimeout(() => {
      modal.fadeOut().removeClass('active');
    }, duration);
  };

  var listupdateData = {};
  var startedAdd = false;

  function enableCheckout() {
    $('#mini-cart [name="checkout"]')
      .removeClass('gokwik-marge')
      .removeAttr('disabled');
  }

  // Get a gift's cart line key using its product ID.
  function removeGiftFromCart(productId) {
    if (!productId) return;

    cart.items.forEach(function (item) {
      if (Number(item.product_id) === Number(productId)) {
        listupdateData[item.key] = 0;
      }
    });
  }

  // Remove both gifts if they are present.
  function allremove() {
    if (free_product?.id) {
      removeGiftFromCart(free_product.id);
    }

    if (second_free_product?.id) {
      removeGiftFromCart(second_free_product.id);
    }
  }

  // Add a free gift and optionally remove its counterpart.
  function addFreeProduct(variantId, counterpartProductId, counterpartAdded) {
    window.FreeGiftGate.begin();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: 1
      },
      dataType: 'json'

    }).done(function () {

      showModal();

      if (counterpartAdded && counterpartProductId) {
        removeGiftFromCart(counterpartProductId);
      }

      finalizeCart(true);

    }).fail(function (error) {

      console.error('Error adding free product:', error);

      finalizeCart(false);

    });
  }

  // Runs after gift add/remove decisions.
  function finalizeCart(addedProduct) {

    var t1 = parseInt(settings.free_mini_threshold);
    var t2 = parseInt(settings.free_mini_threshold_2);
    var t3 = parseInt(settings.free_mini_threshold_3);

    // Check currently claimed free-mini tiers.
    var hasMini = {
      freemini1: false,
      freemini2: false,
      freemini3: false
    };

    cart.items.forEach(function (item) {
      var type = item.properties && item.properties['_mini_type'];

      if (type && hasMini.hasOwnProperty(type)) {
        hasMini[type] = true;
      }
    });

    // Decide which free-mini tiers need removal.
    var removeAll = false;
    var removeTypes = [];

    if (total > t3) {

      if (hasMini.freemini3) {
        removeTypes = ['freemini1', 'freemini2'];
      }

    } else if (total > t2) {

      removeTypes.push('freemini3');

      if (hasMini.freemini2) {
        removeTypes.push('freemini1');
      }

    } else if (total > t1) {

      removeTypes = ['freemini2', 'freemini3'];

    } else {

      removeAll = true;

    }

    cart.items.forEach(function (item) {
      var isFreeMini = item.properties && item.properties['_freemini'];

      if (!isFreeMini) return;

      var type = item.properties && item.properties['_mini_type'];

      if (removeAll || removeTypes.indexOf(type) > -1) {
        listupdateData[item.key] = 0;
      }
    });

    if (Object.keys(listupdateData).length) {

      window.FreeGiftGate.begin();

      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify({
          updates: listupdateData,
          sections: ['mini-cart']
        }),
        dataType: 'json',

        success: function (data) {
          window.FreeGiftGate.settle(data);
          enableCheckout();
        },

        error: function (jqXHR) {
          console.log(jqXHR);

          window.FreeGiftGate.settle(null);
          enableCheckout();
        }
      });

    } else if (addedProduct) {

      refreshCart();
      enableCheckout();

    } else {

      window.FreeGiftGate.settle(null);
      enableCheckout();

    }
  }

  // -----------------------------------------
  // FREE GIFT ADD / REMOVE DECISION
  // -----------------------------------------

  if (hasNoFreeGiftProduct) {

    // Excluded products are in the cart.
    allremove();

  } else {

    var firstGiftAvailable =
      free_product?.available &&
      free_product?.variants?.length > 0;

    var secondGiftAvailable =
      second_free_product?.available &&
      second_free_product?.variants?.length > 0;

    if (firstGiftAvailable && secondGiftAvailable) {

      // Both gifts are available.
      if (
        total >= freeProductThreshold &&
        total < secondFreeProductThreshold
      ) {

        if (!freeProductAdded) {
          startedAdd = true;

          addFreeProduct(
            free_product.variants[0].id,
            second_free_product.id,
            secondFreeProductAdded
          );
        }

      } else if (total >= secondFreeProductThreshold) {

        if (!secondFreeProductAdded) {
          startedAdd = true;

          addFreeProduct(
            second_free_product.variants[0].id,
            free_product.id,
            freeProductAdded
          );
        }

      } else {

        allremove();

      }

    } else if (secondGiftAvailable) {

      // SECOND GIFT ONLY.
      // First gift is empty or unavailable.
      if (total >= secondFreeProductThreshold) {

        if (!secondFreeProductAdded) {
          startedAdd = true;

          addFreeProduct(
            second_free_product.variants[0].id,
            null,
            false
          );
        }

      } else if (secondFreeProductAdded) {

        removeGiftFromCart(second_free_product.id);

      }

    } else if (firstGiftAvailable) {

      // FIRST GIFT ONLY.
      if (total >= freeProductThreshold) {

        if (!freeProductAdded) {
          startedAdd = true;

          addFreeProduct(
            free_product.variants[0].id,
            null,
            false
          );
        }

      } else if (freeProductAdded) {

        removeGiftFromCart(free_product.id);

      }

    } else {

      // Neither gift is available.
      allremove();

    }
  }

  // Async add paths finalize inside .done()/.fail().
  // All other paths finalize here.
  if (!startedAdd) {
    finalizeCart(false);
  }

});


var pageaddedcnt = 0;

function updateNavButtons(stepIndex) {
  stepIndex = parseInt(stepIndex);
  var totalSteps = $('.step_inner_main').length;
  // Show Prev and Next buttons initially
  $('.bundle-step-prev-next.prev').show();
  $('.bundle-step-prev-next.next').show();

  // Disable Prev on first step
  if (stepIndex === 1) $('.bundle-step-prev-next.prev').attr('disabled', true);
  else $('.bundle-step-prev-next.prev').removeAttr('disabled');

  // On last step: hide Next, show cart buttons
  if (stepIndex === totalSteps) {
    $('.bundle-step-prev-next.next').attr('disabled',true);
    // $('[data-review-bundle]').show();
  } else {
    $('.bundle-step-prev-next.next').removeAttr('disabled');
    // $('.bundle-step-prev-next.next').show();
    // $('[data-review-bundle]').hide();
    controlNextBtn(stepIndex);
  }

  // updateProgressBar(stepIndex);
  // if($(window).width() < 640){
  //   updateProgressItems(stepIndex);
  // }
}

function controlNextBtn(stepIndex) {
  var $currentStep = $('.step_inner_main.is-active');
  var $nextBtn = $('.bundle-step-prev-next.next');
  // Step 3 Next always enabled
  // Other steps: Next enabled only if a product is selected
  console.log($currentStep.attr('data-stepitemlimit'),pageaddedcnt)
  if (parseInt($currentStep.attr('data-stepitemlimit')) == parseInt($currentStep.attr('data-addeditemcnt'))) {
    $nextBtn.removeAttr('disabled');
    $('.byob-step_progress-bar--item[step="'+$currentStep.attr('data-step')+'"]').addClass('is-page-selected');
  } else {
    $nextBtn.attr('disabled', true);
    $('.byob-step_progress-bar--item[step="'+$currentStep.attr('data-step')+'"]').removeClass('is-page-selected');
  }
}

updateNavButtons(1);
controlNextBtn(1);

//BUNDLE PAGE
var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
function activecheck(addedcnt,bundle_compare_price,_this){
  if(_this != null){
    console.log(parseInt($(_this).closest('.step_inner_main').attr('data-addeditemcnt')),parseInt($(_this).closest('.step_inner_main').attr('data-stepitemlimit')))
    if(parseInt($(_this).closest('.step_inner_main').attr('data-addeditemcnt')) == parseInt($(_this).closest('.step_inner_main').attr('data-stepitemlimit'))){
      console.log('ifff')
      $(_this).closest('.step_inner_main').find('.bundle-product-item__cta:not(.added),.select_a_size').attr('disabled','disabled');
      $(_this).closest('.step_inner_main').find('.bundle-product-item__cta-wrapper .quantity-selector__button.plus').attr('disabled','disabled');      
      // $('.bundle-step-prev-next.next').removeAttr('disabled');
    }else{
      console.log('elssss')
      $(_this).closest('.step_inner_main').find('.bundle-product-item__cta:not(.added),.select_a_size').removeAttr('disabled');
      $(_this).closest('.step_inner_main').find('.bundle-product-item__cta-wrapper .quantity-selector__button.plus').removeAttr('disabled');      
      // $('.bundle-step-prev-next.next').attr('disabled','disabled');
    }
    if(addedcnt == parseInt($('.bundle-product-list').attr('data-bundleitemcnt'))){
      // $('.bundle-product-item__cta:not(.added),.select_a_size').attr('disabled','disabled');
      // $('.bundle-product-item__cta-wrapper .quantity-selector__button.plus').attr('disabled','disabled');
      $('.bundle-add_to_cart_button').html(`<span class="loader-button__text"><span class="product-item__cta-text">Add to cart<svg width="18" height="18" class="icon icon--quick-buy-shopping-cart   " viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.592726 0.774894C1.04345 0.713177 2.05356 0.720973 2.51557 0.7645C2.80061 0.791136 3.00192 0.917169 3.12425 1.20302C3.37782 1.79745 3.48293 2.71476 3.76025 3.26827C3.83863 3.42484 3.96215 3.52943 4.12605 3.55022L14.4226 3.55737C14.8288 3.58985 15.1049 4.0537 14.9618 4.47468C14.346 6.23005 13.9475 8.17576 13.3079 9.90904C13.1844 10.2436 13.0585 10.4424 12.6999 10.4781L5.84224 10.4794C5.72288 10.497 5.59401 10.5769 5.53225 10.6925C5.46218 10.8238 5.32679 11.4507 5.35589 11.5904C5.38795 11.7437 5.58332 11.8658 5.7205 11.8736L13.438 11.8762C14.1286 12.0256 14.0942 13.1697 13.3822 13.2392H5.54176C4.83865 13.1573 4.25729 12.5648 4.11595 11.8106C3.96096 10.9823 4.5061 10.2631 4.29589 9.4374L2.17352 2.46984C2.12304 2.32497 1.99596 2.19764 1.85403 2.1697C1.38668 2.0768 0.547594 2.33991 0.196637 1.96896C-0.20539 1.54214 0.0499597 0.848955 0.592726 0.774894Z" fill="currentColor"></path>
        <path d="M4.17296 16.3133C2.9271 14.9504 4.95564 12.9748 6.0483 14.4404C7.07148 15.8131 5.29056 17.536 4.17296 16.3133Z" fill="currentColor"></path>
        <path d="M11.7741 16.3133C10.5282 14.9504 12.5567 12.9748 13.6494 14.4404C14.6726 15.8131 12.8917 17.536 11.7741 16.3133Z" fill="currentColor"></path>
      </svg></span></span><span class="loader-button__loader"><div class="spinner"><svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg></div></span>`).addClass('readytoadd button--primary').removeClass('button--outline');
      $('.bundle-preview_cart-prices').show();
    }else{
      // $('.bundle-product-item__cta:not(.added),.select_a_size').removeAttr('disabled');
      // $('.bundle-product-item__cta-wrapper .quantity-selector__button.plus').removeAttr('disabled');
      $('.bundle-add_to_cart_button').html('Add To Box').addClass('button--outline').removeClass('readytoadd button--primary');
      $('.bundle-preview_cart-prices').hide();
    }
    if(parseInt($('.bundle-preview_cart-buttons .data-bundleprice').attr('data-thisprice')) < bundle_compare_price){
      $('.bundle-preview_cart-prices .price--compare').html(window.formatMoney(bundle_compare_price, currencyFormat));  
    }
    
    
    if(addedcnt > 0){
      $('.bundle-preview_cart').show();
    }else{
      $('.bundle-preview_cart').hide();
    }

    updateNavButtons($(_this).closest('.step_inner_main').attr('data-step'))
  }else{
    if(addedcnt == parseInt($('.bundle-product-list').attr('data-bundleitemcnt'))){
      $('.bundle-product-item__cta:not(.added),.select_a_size').attr('disabled','disabled');
      $('.bundle-product-item__cta-wrapper .quantity-selector__button.plus').attr('disabled','disabled');
      $('.bundle-add_to_cart_button').html(`<span class="loader-button__text"><span class="product-item__cta-text">Add to cart<svg width="18" height="18" class="icon icon--quick-buy-shopping-cart   " viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.592726 0.774894C1.04345 0.713177 2.05356 0.720973 2.51557 0.7645C2.80061 0.791136 3.00192 0.917169 3.12425 1.20302C3.37782 1.79745 3.48293 2.71476 3.76025 3.26827C3.83863 3.42484 3.96215 3.52943 4.12605 3.55022L14.4226 3.55737C14.8288 3.58985 15.1049 4.0537 14.9618 4.47468C14.346 6.23005 13.9475 8.17576 13.3079 9.90904C13.1844 10.2436 13.0585 10.4424 12.6999 10.4781L5.84224 10.4794C5.72288 10.497 5.59401 10.5769 5.53225 10.6925C5.46218 10.8238 5.32679 11.4507 5.35589 11.5904C5.38795 11.7437 5.58332 11.8658 5.7205 11.8736L13.438 11.8762C14.1286 12.0256 14.0942 13.1697 13.3822 13.2392H5.54176C4.83865 13.1573 4.25729 12.5648 4.11595 11.8106C3.96096 10.9823 4.5061 10.2631 4.29589 9.4374L2.17352 2.46984C2.12304 2.32497 1.99596 2.19764 1.85403 2.1697C1.38668 2.0768 0.547594 2.33991 0.196637 1.96896C-0.20539 1.54214 0.0499597 0.848955 0.592726 0.774894Z" fill="currentColor"></path>
        <path d="M4.17296 16.3133C2.9271 14.9504 4.95564 12.9748 6.0483 14.4404C7.07148 15.8131 5.29056 17.536 4.17296 16.3133Z" fill="currentColor"></path>
        <path d="M11.7741 16.3133C10.5282 14.9504 12.5567 12.9748 13.6494 14.4404C14.6726 15.8131 12.8917 17.536 11.7741 16.3133Z" fill="currentColor"></path>
      </svg></span></span><span class="loader-button__loader"><div class="spinner"><svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg></div></span>`).addClass('readytoadd button--primary').removeClass('button--outline');
      $('.bundle-preview_cart-prices').show();
    }else{
      $('.bundle-product-item__cta:not(.added),.select_a_size').removeAttr('disabled');
      $('.bundle-product-item__cta-wrapper .quantity-selector__button.plus').removeAttr('disabled');
      $('.bundle-add_to_cart_button').html('Add To Box').addClass('button--outline').removeClass('readytoadd button--primary');
      $('.bundle-preview_cart-prices').hide();
    }
    if(parseInt($('.bundle-preview_cart-buttons .data-bundleprice').attr('data-thisprice')) < bundle_compare_price){
      $('.bundle-preview_cart-prices .price--compare').html(window.formatMoney(bundle_compare_price, currencyFormat));  
    }
    
    
    if(addedcnt > 0){
      $('.bundle-preview_cart').show();
    }else{
      $('.bundle-preview_cart').hide();
    }
  }
}

function qtyatc(totalqty, _this){
  if(totalqty > 0){
    $(_this).closest('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').hide();
    $(_this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector').removeClass('hidden');
    $(_this).closest('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').attr("disabled","disabled").addClass('added button--outline').removeClass('button--primary').html(`Added`);
  }else{
    $(_this).closest('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').show();
    $(_this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector').addClass('hidden');
    $(_this).closest('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').removeAttr("disabled").removeClass('added button--outline').addClass('button--primary').html(`Add to box`);
  }
}
var addedcnt = 0;

var bundle_compare_price = 0;
$('body').on('click', '.bundle-without-step .bundle-product-item__cta', function(e){
  e.preventDefault();
  addedcnt += 1;
  bundle_compare_price += parseInt($(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-compprice'));
  var totalqty = parseInt($(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector [name="quantity"]').val()) + 1;
  qtyatc(totalqty, this);
  $(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector [name="quantity"]').val(totalqty);
  activecheck(addedcnt,bundle_compare_price);     
  // $(this).attr("disabled","disabled").addClass('added button--outline').removeClass('button--primary').html(`Added`);
  // $(this).before(`<span class="bundle-product-item__cta-remove text--xsmall"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" x="0" y="0" viewBox="0 0 320.591 320.591" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path><path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg></span>`);
  var featuredimage = $(this).closest('.product-item').attr('data-featuredimage');
  var itembox = `<div class="bundle-preview_cart-item-wrapper"><img src="${featuredimage}" loading="lazy" width="50" height="50" alt=""><div class="bundle-preview_car-item-remove text--xsmall"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" x="0" y="0" viewBox="0 0 320.591 320.591" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path><path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg></div></div>`; 
  $('.bundle-preview_cart-item.hasblank').first().html(itembox);
  $('.bundle-preview_cart-item.hasblank').first().attr('data-qty', totalqty).attr('data-vid',$(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-vid')).attr('data-pid',$(this).closest('.product-item').attr('data-product-id')).attr('data-price',$(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-price')).removeClass('hasblank');
});

$('body').on('click', '.step-product-list .bundle-product-item__cta', function(e){
  e.preventDefault();
  addedcnt += 1;
  pageaddedcnt += 1;
  var currentStepIndex = $(this).closest('.step_inner_main').attr('data-step');
  $(this).closest('.step_inner_main').attr('data-addeditemcnt',pageaddedcnt);
  $('.byob-step_progress-bar--item[step="'+currentStepIndex+'"]').addClass('is-page-selected');
  bundle_compare_price += parseInt($(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-compprice'));
  var totalqty = parseInt($(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector [name="quantity"]').val()) + 1;
  qtyatc(totalqty, this);
  $(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector [name="quantity"]').val(totalqty);
  
  activecheck(addedcnt,bundle_compare_price,this);     
  // $(this).attr("disabled","disabled").addClass('added button--outline').removeClass('button--primary').html(`Added`);
  // $(this).before(`<span class="bundle-product-item__cta-remove text--xsmall"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" x="0" y="0" viewBox="0 0 320.591 320.591" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path><path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg></span>`);
  var featuredimage = $(this).closest('.product-item').attr('data-featuredimage');
  var itembox = `<div class="bundle-preview_cart-item-wrapper"><img src="${featuredimage}" loading="lazy" width="50" height="50" alt=""><div class="bundle-preview_car-item-remove text--xsmall"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" x="0" y="0" viewBox="0 0 320.591 320.591" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path><path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg></div></div>`; 
  $('.bundle-preview_cart-item.hasblank').first().html(itembox);
  $('.bundle-preview_cart-item.hasblank').first().attr('data-qty', totalqty).attr('data-vid',$(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-vid')).attr('data-pid',$(this).closest('.product-item').attr('data-product-id')).attr('data-price',$(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-price')).removeClass('hasblank');
});

// Next button click handling
$('body').on('click', '.bundle-step-prev-next.next', function() {
  if ($(this).is('[disabled]')) return;
  var $currentStep = $('.step_inner_main.is-active').attr('data-step');
  var nextstep = parseInt($currentStep) + 1;
  // var currentStepIndex = $('.byob-step_item').index($currentStep) + 1;
  var $nextStep = $('.step_inner_main[data-step="'+nextstep+'"]');

  $('.byob-step_progress-bar--item').removeClass('active')
  for(var i = 0;i < $currentStep;i++){
    $('.byob-step_progress-bar--item').eq(i).addClass('active')
  }
  // if($(window).width() < 640){
  //   updateProgressItems(nextstep);
  // }

  if ($nextStep.length) {
    $('.step_inner_main').removeClass('is-active');
    $nextStep.addClass('is-active');
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    pageaddedcnt = 0;
    // $('.byob_slide').removeClass('active');
    // $('.byob_slide[step="'+nextstep+'"]').addClass('active');
    $('.byob-step_progress-bar--item').removeClass('is-page-active');
    $('.byob-step_progress-bar--item[step="'+nextstep+'"]').addClass('is-page-active');
    updateNavButtons(nextstep);
  }
});

$('body').on('click', '.bundle-step-prev-next.prev', function() {
  console.log('ihihihih')
  var $currentStep = $('.step_inner_main.is-active').attr('data-step');
  var prevstep = parseInt($currentStep) - 1;
  // var currentStepIndex = $('.byob-step_item').index($currentStep) + 1;
  var $prevStep = $('.step_inner_main[data-step="'+prevstep+'"]');

  $('.byob-step_progress-bar--item').removeClass('active')
  for(var i = 0;i < $currentStep - 1;i++){
    $('.byob-step_progress-bar--item').eq(i - 1).addClass('active')
  }
  // if($(window).width() < 640){
  //   updateProgressItems(prevstep);
  // }

  if ($prevStep.length) {
    $('.step_inner_main').removeClass('is-active');
    // $('.byob-step_item').removeClass('is-active');
    $prevStep.addClass('is-active');
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    pageaddedcnt = 0;
    // $('.byob_slide').removeClass('active');
    // $('.byob_slide[step="'+prevstep+'"]').addClass('active');
    $('.byob-step_progress-bar--item').removeClass('is-page-active');
    $('.byob-step_progress-bar--item[step="'+prevstep+'"]').addClass('is-page-active');
    updateNavButtons(prevstep);
  }
});

$('body').on('click', '.bundle-product-item__cta-wrapper .quantity-selector__button.plus', function(e){
  addedcnt += 1;
  pageaddedcnt += 1;
  $(this).closest('.step_inner_main').attr('data-addeditemcnt',pageaddedcnt);
  bundle_compare_price += parseInt($(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-compprice'));
  var currentqty = parseInt($(this).closest('.quantity-selector').find('[name="quantity"]').val());
  qtyatc(currentqty, this);
  
  // $(this).closest('.quantity-selector').find('[name="quantity"]').val(totalqty);
  activecheck(addedcnt,bundle_compare_price,this);    
  // $(this).attr("disabled","disabled").addClass('added button--outline').removeClass('button--primary').html(`Added`);
  // $(this).before(`<span class="bundle-product-item__cta-remove text--xsmall"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" x="0" y="0" viewBox="0 0 320.591 320.591" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path><path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg></span>`);
  var featuredimage = $(this).closest('.product-item').attr('data-featuredimage');
  var itembox = `<div class="bundle-preview_cart-item-wrapper"><img src="${featuredimage}" loading="lazy" width="50" height="50" alt=""><div class="bundle-preview_car-item-remove text--xsmall"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" x="0" y="0" viewBox="0 0 320.591 320.591" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path><path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg></div></div>`; 
  $('.bundle-preview_cart-item.hasblank').first().html(itembox);
  $('.bundle-preview_cart-item.hasblank').first().attr('data-qty', currentqty).attr('data-vid',$(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-vid')).attr('data-pid',$(this).closest('.product-item').attr('data-product-id')).attr('data-price',$(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-price')).removeClass('hasblank');
});

$('body').on('click', '.bundle-product-item__cta-wrapper .quantity-selector__button.minus', function(e){
  addedcnt = addedcnt - 1;
  pageaddedcnt = pageaddedcnt - 1;
  $(this).closest('.step_inner_main').attr('data-addeditemcnt',pageaddedcnt);
  bundle_compare_price = bundle_compare_price - parseInt($(this).next().attr('data-compare_price'));
  activecheck(addedcnt,bundle_compare_price,this);    
  var currentqty = parseInt($(this).closest('.quantity-selector').find('[name="quantity"]').val());
  qtyatc(currentqty, this);
  
  $(`.bundle-preview_cart-item[data-qty="${currentqty + 1}"][data-pid="${$(this).closest('.product-item').attr('data-product-id')}"]`).addClass('hasblank').removeAttr('data-pid').removeAttr('data-vid').removeAttr('data-price').html('<div class="bundle-preview_cart-item-wrapper">Add</div>');    
  
});

// $('body').on('click', '.bundle-product-item__cta-remove', function(e){
//   e.preventDefault();    
//   addedcnt = addedcnt - 1;
//   bundle_compare_price = bundle_compare_price - parseInt($(this).next().attr('data-compare_price'));
//   activecheck(addedcnt,bundle_compare_price); 
//   $(this).next().removeAttr("disabled").removeClass('added button--outline').addClass('button--primary').html(`Add to box`);
//   $(`.bundle-preview_cart-item[data-pid="${$(this).closest('.product-item').attr('data-product-id')}"]`).addClass('hasblank').removeAttr('data-pid').removeAttr('data-vid').removeAttr('data-price').html('<div class="bundle-preview_cart-item-wrapper">Add</div>');
//   $(this).remove();
// });

$('body').on('click','.bundle-preview_car-item-remove', function(){
  addedcnt = addedcnt - 1;
  bundle_compare_price = bundle_compare_price - parseInt($(this).closest('.bundle-preview_cart-item').attr('data-price'));
  activecheck(addedcnt,bundle_compare_price); 
  var currentqty = $(`.product-item[data-product-id="${$(this).closest('.bundle-preview_cart-item').attr('data-pid')}"]`).find('[name="quantity"]').val();
  var tochangeqty = parseInt(currentqty) - 1;
  $(`.product-item[data-product-id="${$(this).closest('.bundle-preview_cart-item').attr('data-pid')}"]`).find('[name="quantity"]').val(tochangeqty);
  if(tochangeqty == 0){
    $(`.product-item[data-product-id="${$(this).closest('.bundle-preview_cart-item').attr('data-pid')}"]`).find('.quantity-selector').addClass('hidden');
    $(`.product-item[data-product-id="${$(this).closest('.bundle-preview_cart-item').attr('data-pid')}"]`).find('.bundle-product-item__cta').removeAttr("disabled").removeClass('added button--outline').addClass('button--primary').html(`Add to box`).show();
  }
  // $(`.product-item[data-product-id="${$(this).closest('.bundle-preview_cart-item').attr('data-pid')}"]`).find('.bundle-product-item__cta-remove').remove();    
  $(this).closest('.bundle-preview_cart-item').addClass('hasblank').removeAttr('data-pid').removeAttr('data-vid').removeAttr('data-price').html('<div class="bundle-preview_cart-item-wrapper">Add</div>');
});

$('body').on('click','.bundle-add_to_cart_button.readytoadd ', function(){
  $(this).attr("aria-busy",true);
  var items = [];
  $(this).closest('.bundle-preview_cart-main').find('.bundle-preview_cart-item:not(.hasblank)').each(function(i,v){
    var val = $(this).attr('data-vid');         
      items.push({
      quantity: 1,
      id: val
    });   
  });    
  
  var data = {items};
  console.log('data',data)
  // var data = theme.utils.serialize(this.form);
  
  fetch('/cart/add.js', {
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.json())
  .then(function(data) {      
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
    document.getElementById('mini-cart').open = true;
    $(this).removeAttr("aria-busy");
  }.bind(this));  
  
});

$('body').on('change','.product-variants-selection input[type="radio"]', function(){
  var checkedinput = $(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked');
  if(checkedinput.attr('data-price') < checkedinput.attr('data-compprice')){
    var pricehtml = `<span class="price price--highlight">${window.formatMoney(checkedinput.attr('data-price'),currencyFormat)}</span>
          <span class="price price--compare">${window.formatMoney(checkedinput.attr('data-compprice'), currencyFormat)}</span>`;  
  }else{
    var pricehtml = `<span class="price">${window.formatMoney(checkedinput.attr('data-price'), currencyFormat)}</span>`; 
  }
  $(this).closest('.product-item').find('.price-list').html(pricehtml);
  if($(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').length > 0){
    $(this).closest('.product-item').find('.bundle-product-item__cta-wrapper .select_a_size').addClass('size_not_selected');
    $(this).closest('.product-item').find('.bundle-product-item__cta-wrapper .bundle-product-item__cta').removeClass('size_not_selected'); 
  }else{
    $(this).closest('.product-item').find('.bundle-product-item__cta-wrapper .select_a_size').removeClass('size_not_selected');
    $(this).closest('.product-item').find('.bundle-product-item__cta-wrapper .bundle-product-item__cta').addClass('size_not_selected'); 
  }    
});

$('body').on('click','.select_a_size', function(){
  var _this = $(this);
  _this.closest('.product-item__info').find('.product-variants-selection').addClass('shake');
  setTimeout(function(){
    _this.closest('.product-item__info').find('.product-variants-selection').removeClass('shake');
  },1000)
});


// (function () {
//   // ── config ──
//   var CLIENT_ID = '670d378c47ed9118e34e43cc',
//       USERNAME  = 'mahesh.chand+api@freecultr.com',
//       PASSWORD  = 'Setting@1234',
//       SRC_PIN   = '110020';
//   var AUTH = 'https://app.goswift.in/integrations/v2/auth/token/' + CLIENT_ID,
//       EDD  = 'https://app.goswift.in/data/package/edd';

//   var tok = { v: null, exp: 0 };

//   async function token() {
//     if (tok.v && Date.now() < tok.exp - 60000) return tok.v;
//     var r = await fetch(AUTH, { method: 'POST', headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ username: USERNAME, password: PASSWORD }) });
//     if (!r.ok) throw 0;
//     var d = await r.json();
//     tok = { v: d.access_token, exp: Date.now() + (d.expires_in > 0 ? d.expires_in : 300) * 1000 };
//     return tok.v;
//   }

//   async function lookup(destPin) {
//     var t = await token();
//     var r = await fetch(EDD, { method: 'POST',
//       headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + t },
//       body: JSON.stringify({ srcPin: SRC_PIN, destPin: destPin }) });
//     if (!r.ok) throw 0;
//     return r.json();
//   }

//   function ordinal(v) {
//     var d = new Date(v); if (isNaN(d)) return String(v);
//     var n = d.getDate(), s = (n % 10 == 1 && n != 11) ? 'st' : (n % 10 == 2 && n != 12) ? 'nd'
//       : (n % 10 == 3 && n != 13) ? 'rd' : 'th';
//     return n + s + ' ' + d.toLocaleString('en-US', { month: 'long' });
//   }

//   function init(root) {
//     var input = root.querySelector('.input__field'),
//         btn   = root.querySelector('.pincode-checker__submit'),
//         res   = root.querySelector('.pincode-checker__result'),
//         out   = res && res.querySelector('span');
//     if (!input || !btn || !out) return;
//     res.hidden = true;

//     var say = function (h, err) {
//       out.innerHTML = h; res.hidden = false;
//       res.classList.toggle('pincode-checker__result--error', !!err);
//     };

//     async function go() {
//       var p = (input.value || '').trim();
//       if (!/^\d{6}$/.test(p)) return say('Please enter a valid 6-digit pin code.', 1);
//       btn.disabled = true; btn.setAttribute('aria-busy', 'true');
//       say('Checking delivery date&hellip;');
//       try {
//         var d = await lookup(p);
//         var edd = d.edd || d.estimatedDeliveryDate || (d.data && d.data.edd);
//         var area = d.city || d.area || (d.data && d.data.city) || '';
//         if (!edd) return say('Sorry, delivery is not available for this pin code.', 1);
//         say((area ? 'Area, <strong>' + area + ' &ndash; ' + p + '</strong>; ' : '') +
//             'Your order will be delivered on <strong>' + ordinal(edd) + '</strong>');
//       } catch (e) { say('Could not check delivery date. Please try again.', 1); }
//       finally { btn.disabled = false; btn.removeAttribute('aria-busy'); }
//     }

//     btn.addEventListener('click', go);
//     input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
//     input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 6); });
//   }

//   function boot() { document.querySelectorAll('.pincode-checker').forEach(init); }
//   document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
// })();

// ================================================================================================
(function () {
  var SELECTOR = '[data-sourced-timeline]';

  // Load ScrollTrigger (matching the theme's GSAP version) only if it isn't already present.
  function ensureScrollTrigger(cb) {
    var g = window.gsap;
    if (!g) return cb(false);
    if (window.ScrollTrigger) return cb(true);

    var version = g.version || '3.12.5';
    var src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/' + version + '/ScrollTrigger.min.js';
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.onload = function () { cb(!!window.ScrollTrigger); };
    s.onerror = function () { cb(false); };
    document.head.appendChild(s);
  }

  function setup(root) {
    if (root.dataset.stlReady === '1') return;

    var viewport = root.querySelector('[data-stl-viewport]');
    var track = root.querySelector('[data-stl-track]');
    if (!viewport || !track) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // No GSAP or reduced motion -> keep the native horizontal-scroll fallback from CSS.
    if (reduce || !window.gsap) return;

    ensureScrollTrigger(function (ok) {
      if (!ok) return; // native scroll fallback stays in place
      if (root.dataset.stlReady === '1') return;
      root.dataset.stlReady = '1';

      var gsap = window.gsap;
      var ScrollTrigger = window.ScrollTrigger;
      gsap.registerPlugin(ScrollTrigger);

      var mm = gsap.matchMedia();

      mm.add('(min-width: 750px)', function () {
        root.classList.add('stl--pinned');

        var getAmount = function () {
          return Math.max(0, track.scrollWidth - viewport.clientWidth);
        };

        var scrubSetting = root.dataset.scrub === 'true' ? true : 1;

        var tween = gsap.to(track, {
          x: function () { return -getAmount(); },
          ease: 'none',
          scrollTrigger: {
            trigger: root,
            start: 'top top',
            end: function () { return '+=' + getAmount(); },
            pin: true,
            scrub: scrubSetting,
            anticipatePin: 1,
            invalidateOnRefresh: true
          }
        });

        // Recalculate once images have loaded (card thumbnails change track width).
        root.querySelectorAll('img').forEach(function (img) {
          if (!img.complete) {
            img.addEventListener('load', function () { ScrollTrigger.refresh(); }, { once: true });
          }
        });

        // matchMedia cleanup: runs when the query stops matching or the section reloads.
        return function () {
          root.classList.remove('stl--pinned');
          if (tween.scrollTrigger) tween.scrollTrigger.kill();
          tween.kill();
          gsap.set(track, { clearProps: 'transform' });
        };
      });

      root._stlMM = mm; // keep a handle for teardown in the theme editor
    });
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll(SELECTOR);
    nodes.forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // ---- Shopify theme editor support ----
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector(SELECTOR) || (e.target.matches && e.target.matches(SELECTOR) ? e.target : null);
    if (root && root._stlMM && root._stlMM.revert) {
      root._stlMM.revert();
      root.dataset.stlReady = '';
    }
  });
})();
// ========================================================
// When the cart drawer opens, close any other open drawer, modal, or popover.
(() => {
  const overlaySelector = [
    'drawer-content',
    'mobile-navigation',
    'predictive-search-drawer',
    'quick-buy-drawer',
    'modal-content',
    'popover-content',
    'quick-buy-popover',
    'sort-by-popover',
    'combo-box',
    'product-image-zoom'
  ].join(',');

  document.addEventListener('openable-element:open', (event) => {
    const opened = event.target;

    // Only react when the cart drawer itself opens
    if (!opened || opened.tagName !== 'CART-DRAWER') return;

    document.querySelectorAll(overlaySelector).forEach((element) => {
      // Never close the drawer that just opened, and skip anything already closed
      if (element === opened || !element.open) return;
      element.open = false;
    });
  });
})();

// ===================================================
(function () {
  if (window.__cartTimer) return; // guard: single ticker per page load
  window.__cartTimer = true;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick() {
    var els = document.querySelectorAll('[data-cart-timer]');
    if (!els.length) return;

    var now = Math.floor(Date.now() / 1000);

    els.forEach(function (el) {
      var duration = parseInt(el.getAttribute('data-duration'), 10) || 300;
      var remaining = duration - (now % duration); // loops forever
      var min = el.querySelector('[data-cart-timer-min]');
      var sec = el.querySelector('[data-cart-timer-sec]');
      if (min) min.textContent = pad(Math.floor(remaining / 60)) + 'm';
      if (sec) sec.textContent = pad(remaining % 60) + 's';
    });
  }

  tick();
  setInterval(tick, 1000);
})();
// ===============================================================================================
(function () {
  // Your deployed Worker URL:
  var PROXY = 'https://gentle-glade-c6b7.rupesh-yadav.workers.dev/';

  async function lookup(destPin) {
    var r = await fetch(PROXY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ destPin: destPin })
    });
    if (!r.ok) throw 0;
    return r.json();
  }

  // GoSwift returns edd as day-counts: { min, max } from today
  function pickDays(d) {
    var e = (d.data && d.data.edd) || d.edd;
    if (e && typeof e === 'object') {
      var min = e.min, max = e.max;
      if (min != null || max != null) return { min: min, max: max };
    }
    return null;
  }

  function pickArea(d) {
    var data = d.data || d;
    return data.city || data.area || '';
  }

  function addDays(n) {
    var d = new Date();
    d.setDate(d.getDate() + n);
    return d;
  }

  function ordinal(d) {
    var n = d.getDate(), s = (n % 10 == 1 && n != 11) ? 'st' : (n % 10 == 2 && n != 12) ? 'nd'
      : (n % 10 == 3 && n != 13) ? 'rd' : 'th';
    return n + s + ' ' + d.toLocaleString('en-US', { month: 'long' });
  }

  function init(root) {
    var input = root.querySelector('.input__field'),
        btn   = root.querySelector('.pincode-checker__submit'),
        res   = root.querySelector('.pincode-checker__result'),
        out   = res && res.querySelector('span');
    if (!input || !btn || !out) return;
    res.hidden = true;

    var say = function (h, err) {
      out.innerHTML = h; res.hidden = false;
      res.classList.toggle('pincode-checker__result--error', !!err);
    };

    async function go() {
      var p = (input.value || '').trim();
      if (!/^\d{6}$/.test(p)) return say('Please enter a valid 6-digit pin code.', 1);
      btn.disabled = true; btn.setAttribute('aria-busy', 'true');
      say('Checking delivery date&hellip;');
      try {
        var d = await lookup(p);
        var days = pickDays(d);
        var area = pickArea(d);
        if (!days) return say('Sorry, delivery is not available for this pin code.', 1);

        var min = days.min, max = days.max;
        var dateText;
        if (max != null && min != null && max !== min) {
          dateText = ordinal(addDays(min)) + ' &ndash; ' + ordinal(addDays(max));
        } else {
          dateText = ordinal(addDays(max != null ? max : min));
        }

        say((area ? 'Area, <strong>' + area + ' &ndash; ' + p + '</strong>; ' : '') +
            'Your order will be delivered by <strong>' + dateText + '</strong>');
      } catch (e) { say('Could not check delivery date. Please try again.', 1); }
      finally { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }

    btn.addEventListener('click', go);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
    input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 6); });
  }

  function boot() { document.querySelectorAll('.pincode-checker').forEach(init); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();

// ===============================================================
(function () {
  var SELECTOR = '[data-collection-hero-slider]';

  function initSlider(el) {
    if (!el || el.dataset.swiperInitialized === 'true') return;
    if (typeof Swiper === 'undefined') return;

    var slideCount = el.querySelectorAll('.swiper-slide').length;

    el.swiperInstance = new Swiper(el, {
      slidesPerView: 1,
      loop: slideCount > 1,
      speed: 500,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev')
      }
    });

    el.dataset.swiperInitialized = 'true';
  }

  function destroySlider(el) {
    if (el && el.swiperInstance) {
      el.swiperInstance.destroy(true, true);
      el.swiperInstance = null;
      delete el.dataset.swiperInitialized;
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(initSlider);
  }

  // Swiper bundle is deferred and ordered before this file, so it is ready here.
  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  }

  // Theme editor lifecycle
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll(SELECTOR).forEach(destroySlider);
  });
})();
// =====================================
$(document).on('cart:updated cart:refresh', function () {
  // wait for Focal to swap in the new drawer markup, then reset scroll
  setTimeout(function () {
    $('#mini-cart .drawer__content').scrollTop(0);
  }, 300);
});
$('.product-item__label-list,.product-media__label-list').each(function () {
  const $list = $(this);
  const $labels = $list.find('.label');
  let currentIndex = 0;

  function switchActive() {
    $labels.removeClass('active');
    $labels.eq(currentIndex).addClass('active');

    currentIndex++;
    if (currentIndex >= $labels.length) {
      currentIndex = 0;
    }
  }

  // initial run
  switchActive();

  // individual interval for each list
  setInterval(switchActive, 2000);
});

/**
 * ----------------------------------------------------------------------------------------------------------------------
 * FEATURE SLIDER: <scroll-carousel> moves the list one page at a time when the <prev-next-buttons> are clicked
 * (desktop). On mobile the arrows are hidden and the list is scrolled natively.
 * ----------------------------------------------------------------------------------------------------------------------
 */
if (!window.customElements.get('scroll-carousel')) {
  class ScrollCarousel extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-carousel-list]');
      this.prevButton = this.querySelector('.prev-next-button--prev');
      this.nextButton = this.querySelector('.prev-next-button--next');

      if (!this.list) {
        return;
      }

      this._onPrev = () => this._scroll(-1);
      this._onNext = () => this._scroll(1);
      this._onScroll = () => this._updateButtons();

      this.addEventListener('prev-next:prev', this._onPrev);
      this.addEventListener('prev-next:next', this._onNext);
      this.list.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll);

      this._updateButtons();
    }

    disconnectedCallback() {
      this.removeEventListener('prev-next:prev', this._onPrev);
      this.removeEventListener('prev-next:next', this._onNext);
      this.list?.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
    }

    get _directionFlip() {
      return (window.themeVariables?.settings?.direction || 'ltr') === 'ltr' ? 1 : -1;
    }

    _scroll(direction) {
      const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
      this.list.scrollBy({ left: (this.list.clientWidth + gap) * direction * this._directionFlip, behavior: 'smooth' });
    }

    _updateButtons() {
      const scrollLeft = Math.abs(this.list.scrollLeft),
            maxScroll = this.list.scrollWidth - this.list.clientWidth;

      this.prevButton?.toggleAttribute('disabled', scrollLeft <= 1);
      this.nextButton?.toggleAttribute('disabled', scrollLeft >= maxScroll - 1);
    }
  }

  window.customElements.define('scroll-carousel', ScrollCarousel);
}

$(function () {
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (!isIOS) return;

  var $viewport = $('meta[name="viewport"]');
  var defaultContent = $viewport.attr('content');
  var lockedContent = defaultContent + ', maximum-scale=1';
  var fields = 'input, select, textarea';

  $(document).on('touchstart', fields, function () {
    $viewport.attr('content', lockedContent);
  });

  $(document).on('blur', fields, function () {
    $viewport.attr('content', defaultContent);
  });
});